import LoadInViewport from './LoadInViewport.vue'

export default LoadInViewport
